module.exports = __webpack_public_path__ + "img/SketchPng95883489cbe1d814a3aaf0297dbb257e4ce05b45bead4d0ec61c824bb27ba289.4420c317.png";